function parse(jwtString) {
  let jwtParts = jwtString.split('.');
  if (jwtParts.length !== 3) {
    throw new Error('Error parsing JWT: It does not contain the right amount of parts');
  }

  return {
    header: JSON.parse(atob(jwtParts[0])),
    payload: JSON.parse(b64DecodeUnicode(jwtParts[1])),
    signature: jwtParts[2]
  };
}

function b64DecodeUnicode(str) {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
}

/**
 * Load ./lib/jose/jose.min.js somewhere first to use this function
 *
 * */
function validate(Jose, jwtString, jwsKeys) {
  let jwt = parse(jwtString);

  let kid = jwt.header.kid;
  if ((kid || undefined) === undefined) {
    throw new Error('JWT validation error: No Key ID present in JWT header');
  }

  let relevantVerificationKeys = jwsKeys.keys.filter((k) => k.kid === kid);
  if (relevantVerificationKeys.length === 0) {
    throw new Error('JWT validation error: Key used to sign JWT not found in key set');
  }

  let verificationKey = relevantVerificationKeys[0];
  if (jwt.header.alg !== verificationKey.alg) {
    throw new Error('JWT validation error: JWT is signed with different algorithm that key states it is used for');
  }

  let cryptographer = new Jose.WebCryptographer();
  cryptographer.setContentSignAlgorithm(verificationKey.alg);

  let verifier = new Jose.JoseJWS.Verifier(cryptographer, jwtString);
  return verifier
    .addRecipient(verificationKey, kid)
    .then(() => {
      return verifier.verify();
    })
    .then((verificationResult) => {
      return Promise.resolve(verificationResult[0].verified);
    });
}

export default {
  parse,
  validate
};
